/* Locked drop — Highlight banner enhancement (decorative only).
   - Adds .lkh--visible when the banner scrolls into view (triggers the
     gradient "mark" fill animation).
   - On pointer move, positions the red dot-spotlight (--hx/--hy).
   Text is fully readable without this script. */
(function () {
  function init(el) {
    if (el.dataset.lkhInit) return;
    el.dataset.lkhInit = '1';

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('lkh--visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.35 });
      io.observe(el);
    } else {
      el.classList.add('lkh--visible');
    }

    // Cursor spotlight (pointer devices only)
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--hx', (ev.clientX - r.left) + 'px');
        el.style.setProperty('--hy', (ev.clientY - r.top) + 'px');
      });
    }
  }

  function run() {
    document.querySelectorAll('[data-lkh]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
